// extracted by mini-css-extract-plugin
module.exports = {"required":"MantineInputWrapper_required__KGecu","description":"MantineInputWrapper_description__Dr6oB"};